import { AccordionGroup, Stack } from "@mui/joy";
import AccordionTemplate from "./AccordionTemplate";
import ListItem from "@mui/joy/ListItem";
import List from "@mui/joy/List";
import { theme } from "styles/theme";

const counselingDifferences = [
  "코치 선생님이 매일 피드백과 맞춤 활동을 준비해 줍니다.",
  "비실시간으로 코치 선생님과 소통하기에, 언제든 편한 시간에 참여할 수 있습니다.",
  "마음 건강을 다스리는 데에 필요한 인지치료 이론과 기술들을 체계적으로 습득합니다.",
];

export default function FAQTypeC() {
  return (
    <AccordionGroup
      sx={{
        display: "flex",
        "& .MuiAccordionSummary-button": {
          backgroundColor: "transparent !important",
          boxShadow: "none !important",
          "&:hover, &:focus, &:active, &.Mui-focusVisible": {
            backgroundColor: "transparent !important",
            boxShadow: "none !important",
            outline: "none !important",
          },
        },
        // 혹시 다른 슬롯도 필요하면 추가
        "& .MuiAccordionSummary-content": {
          backgroundColor: "transparent !important",
        },
      }}
    >
      <Stack>
        <AccordionTemplate
          summary={"더 길게 코칭을 받을 수 있나요?"}
          details={[
            "100일의 집중 코칭 기간이 끝나면 대부분 혼자서 디스턴싱을 공부하고 연습하며 일상에 적용할 수 있게 됩니다.",
            <br />,
            <br />,
            "우선 코칭 기간 동안 충분히 집중해보시고, 이후에도 추가 코칭이 필요하시다면 고객센터로 문의해 주세요. 최대한 도움 드리겠습니다.",
          ]}
        />
        <AccordionTemplate
          summary={"코치 선생님이 도와준다고요?"}
          details={[
            "코치는 매일 해야할 활동을 안내하고 프로그램을 리드해 나갈 거예요. 코치와는 익명으로 프로그램 진행이 가능해요.",
            <br />,
            <br />,
            "코치는 심리학 분야에서 석사 이상의 학위를 갖추고, 상담심리사(한국상담심리학회), 임상심리전문가(한국심리학회/한국임상심리학회), 정신건강임상심리사(보건복지부), 전문상담사(한국상담학회) 자격증을 갖춘 심리전문가들로 구성되어 있어요.",
            <br />,
            <br />,
            "아울러 디스턴싱은 자체 기술을 활용해 모든 코치가 정확하고 효율적인 피드백을 제공할 수 있도록 가이드를 제공하고 있답니다. 코치의 배경이나 직종과 무관하게 치료 결과는 동일하게 유지된다는 실제 연구 결과들이 있으니 안심하셔도 좋아요.",
          ]}
        />
        <AccordionTemplate
          summary={"누가 도움 받을 수 있나요?"}
          details={[
            "우울함, 수치심, 무기력, 폭식을 비롯한 식이장애, 불안감, 강박적인 걱정, 공황장애, 사회공포증, 발표불안, 자기 파괴적 완벽주의, 업무에 대한 부담감, 수면 문제 그리고 이외 복합적인 정서 문제에 도움이 될 수 있어요.",
            <br />,
            <br />,
            "환청, 환각, 자살사고 등 시급한 의료적 접근이 필요한 분들의 경우 당장의 도움이 될 수 없어요. 단, 의료적 접근을 통해 위 문제들이 안정화가 된 상태에서는 보다 장기적이고 지속적인 변화를 위해 디스턴싱을 시작해봐도 괜찮아요.",
          ]}
        />
        <AccordionTemplate
          summary={"심리상담과 무엇이 다른가요?"}
          details={[
            "대화를 통해 진행되는 심리상담과 달리 디스턴싱 프로그램은 다음과 같은 차이를 갖습니다.",
            <br />,
            <br />,
            <List marker="disc" sx={{ py: 0 }}>
              {counselingDifferences.map((text, index) => (
                <ListItem
                  key={index}
                  sx={{
                    minHeight: "auto",
                    fontWeight: 500,
                    color: theme.vars.palette.Content.Strong,
                    lineHeight: 1.32,
                    p: 0,
                    pb: 0.5,
                  }}
                >
                  {text}
                </ListItem>
              ))}
            </List>,
          ]}
        />
        <AccordionTemplate
          summary={"환불이 가능한가요?"}
          details={[
            "프로그램을 통해 배운 방법론을 실생활에 스스로 적용해내기까지 평균적으로 최소 100일의 시간이 필요합니다. 100일간 코치의 가이드를 꾸준히 따라 프로그램을 진행하신다면, 의미 있는 변화를 경험하실 수 있을 겁니다.",
            <br />,
            <br />,
            "결제 후 활동지를 한 번도 진행하지 않으신 경우에 한해 전액 환불이 가능합니다. 활동지를 1회 이상 마치셨다면 환불은 불가합니다.",
            <br />,
            <br />,
            "환불 요청은 서비스 내 ‘고객센터’에서 접수해주시면 됩니다.",
          ]}
        />
        <AccordionTemplate
          summary={"효과를 못 느끼면 페이백해준다고요?"}
          details={[
            "첫 100일의 집중 코칭 기간을 모두 이용하신 뒤에도 변화를 느끼지 못하신 경우, 비용 전액을 돌려드립니다.",
            <br />,
            <br />,
            "결제 이후 100일 동안 최소 주 1회 주어진 모든 활동지를 마치며 프로그램을 꾸준히 진행하신 경우에만 페이백이 가능합니다.",
            <br />,
            <br />,
            "주 1회 이상 참여하는 게 어려울 것 같나요? 그렇지 않아요. 30분 정도면 충분하고, 전담 코치 선생님이 꾸준히 프로그램에 참여할 수 있도록 도와줄 거랍니다.",
            <br />,
            <br />,
            "페이백은 100일의 집중 코칭 기간을 모두 이용하신 후, 10일 이내에 신청이 가능합니다.",
            <br />,
            <br />,
            "페이백 요청은 서비스 내 ‘고객센터’에서 접수해주시면 됩니다.",
          ]}
          noBorder
        />
      </Stack>
    </AccordionGroup>
  );
}